import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function NotiAlertShowComp({ open, handleCloseComp, compList }) {
  return (
    <div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="xs"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
          },
        }}
      >
        <DialogActions
          sx={{
            backgroundColor: 'primary.main',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50px',
          }}
        >
          <Box
            component="section"
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              textAlign: 'center',
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            บริษัท
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleCloseComp}
            sx={{ position: 'absolute', right: 0, color: 'white' }}
          >
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers>
          <Box
            sx={{
              height: '100%',
              marginTop: '4px',
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1',
                borderRadius: '4px',
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <List>
                {compList?.map((item, index) => (
                  <ListItem key={index}>
                    <ListItemText primary={`${index + 1}. ${item}`} />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Box>
        </DialogContent>
        {/* <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              setOpen(false);
            }}
          >
            ยกเลิก
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}
